export default __webpack_public_path__ + "static/media/loan.6947fece.svg";